import type { GetCertificationsInput } from './dtos/models';
import type { Certification, CertificationInput, CertificationItem } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CertificationService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getByInput = (input: GetCertificationsInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Certification[]>({
      method: 'GET',
      url: '/api/app/certification',
      params: { supervisorIds: input.supervisorIds },
    },
    { apiName: this.apiName,...config });
  

  getInputsByInput = (input: GetCertificationsInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CertificationInput[]>({
      method: 'GET',
      url: '/api/app/certification/inputs',
      params: { supervisorIds: input.supervisorIds },
    },
    { apiName: this.apiName,...config });
  

  getItemsByInput = (input: GetCertificationsInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CertificationItem[]>({
      method: 'GET',
      url: '/api/app/certification/items',
      params: { supervisorIds: input.supervisorIds },
    },
    { apiName: this.apiName,...config });
}